<template>
  <v-container class="meals">
    <v-row>
      <v-col>
        <h5>Journal entries</h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <meal
          v-for="meal in meals"
          :key="meal.id"
          :comment="meal.bhComment"
          :comments="meal.comments"
          :commentEditable="meal.bhCommentEditable"
          :picture="meal.thumbnailUrl || meal.previewUrl || meal.fileUrl"
          :resourceId="meal.resourceId"
          :reaction="meal.bhReaction"
          @updateMealBase="updateMeal(meal, $event)"
          v-on="$listeners"
          :hoverLoader="progressBarsValues[meal.resourceId]"
          @mealOpenHover="mealOpenHover"
          @addMealComment="addMealComment(meal, $event)"
          @mealClearHover="mealClearHover"
        />
      </v-col>
    </v-row>
    <v-dialog
      v-model="mealHover"
      hide-overlay
      attach=".meals"
      :content-class="
        !!mealNote
          ? 'meal-hover-dialog meal-hover-dialog--note'
          : 'meal-hover-dialog'
      "
      @click:outside="onClickOutside"
      @keydown="onKeydown"
    >
      <v-card @mouseleave.native.stop="mealCloseHover()" :outlined="!!mealNote">
        <img v-if="mealHoverUrl" :src="mealHoverUrlComputed" />
        <div v-else-if="!!mealNote">
          <v-card-title class="headline">{{ mealTitle }}</v-card-title>
          <v-card-text>{{ mealNote }}</v-card-text>
        </div>
        <v-btn color="white" icon size="24" @click="mealCloseHover">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Meal from '@/components/journal/components/Meal.vue'
import { mapState, mapActions } from 'vuex'
import isStringBase64 from '@/helpers/isStringBase64.js'

export default {
  name: 'Meals',
  components: {
    Meal,
  },
  props: {
    meals: {
      type: Array,
      default: function() {
        return []
      },
    },
  },
  data: () => {
    return {
      viewedYear: 0,
      viewedMonth: 0,
      mealHover: false,
      mealHoverUrl: null,
      mealHoverType: 'base64',
      mealHoverTimeout: null,
      mealHoverInterval: null,
      progressBarsValues: {},
      mealNote: null,
      mealTitle: '',
    }
  },
  computed: {
    ...mapState('dictionariesStates', ['dictionaryFileType']),
    mealHoverUrlComputed() {
      if (this.mealHoverUrl) {
        if (this.mealHoverType == 'base64')
          return 'data:image/jpeg;base64,' + this.mealHoverUrl
        else return this.mealHoverUrl
      } else return ''
    },
  },
  methods: {
    isStringBase64,
    ...mapActions('resourcesStates', ['getResourceById']),
    updateMeal(meal, changes) {
      this.$emit('updateMeal', { ...meal, ...changes })
    },
    addMealComment(meal, comment) {
      this.$emit('addSelectedMealComment', {
        mealId: meal.id,
        comment: comment,
      })
    },
    mealOpenHover(id, thumbnailUrl = false, previewUrl, fileUrl, fileTypeId) {
      let typeName = this.dictionaryFileType[fileTypeId]
      clearTimeout(this.mealHoverTimeout)
      this.mealCloseHover()
      if ((id && thumbnailUrl) || typeName === 'txt') {
        this.progressBarsValues = { ...this.progressBarsValues, ...{ [id]: 1 } }
        if (this.mealHoverInterval) clearInterval(this.mealHoverInterval)
        this.mealHoverInterval = setInterval(() => {
          if (this.progressBarsValues[id] >= 100) {
            clearInterval(this.mealHoverInterval)
            return
          }
          let tmp = this.progressBarsValues[id]
          this.progressBarsValues = {
            ...this.progressBarsValues,
            ...{ [id]: tmp + 33 },
          }
        }, 200)
        if (this.mealHoverTimeout) clearTimeout(this.mealHoverTimeout)
        this.mealHoverTimeout = setTimeout(() => {
          this.mealHover = null
          if (previewUrl) {
            this.mealHoverUrl = previewUrl
            this.mealHoverType = this.isStringBase64(previewUrl)
              ? 'base64'
              : 'url'
            this.mealHover = true
          } else {
            this.getResourceById({ resourceId: id }).then(response => {
              const { data } = response
              this.mealTitle = data.title
              if (data.fileUrl) {
                if (this.mealHover === null) {
                  this.mealHoverUrl = data.previewUrl || data.thumbnailUrl // in case preview is not available
                  this.mealHoverType = this.isStringBase64(
                    data.previewUrl || data.thumbnailUrl,
                  )
                    ? 'base64'
                    : 'url'
                  this.mealHover = true
                  fetch(data.fileUrl)
                    .then(response => {
                      return response.text()
                    })
                    .then(data => {
                      this.mealNote = data
                      this.mealHover = true
                    })
                }
              }
            })
          }
        }, 1000)
      } else this.mealClearHover(id)
    },
    mealClearHover(id) {
      this.progressBarsValues = { ...this.progressBarsValues, ...{ [id]: 0 } }

      clearInterval(this.mealHoverInterval)
      if (!this.mealHover) {
        clearTimeout(this.mealHoverTimeout)
        this.mealHover = false
        this.mealHoverUrl = null
        this.mealNote = null
        this.mealHoverType = 'base64'
      }
    },
    mealCloseHover() {
      this.mealHover = false
      this.mealNote = null
    },
    onClickOutside() {
      this.mealCloseHover()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.mealCloseHover()
    },
  },
}
</script>
<style lang="scss">
.meals {
  padding: 0px;
  h5 {
    padding: 0;
    color: $bh-gray--2;
  }
  .col {
    padding: 8px 12px;
  }
  &--card {
    background: $bh-blue--4;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    .icon {
      width: 35px;
      img {
        max-width: 30px;
      }
    }
  }
}
.meal-hover-dialog {
  width: auto !important;
  padding: 10px;
  background: $bh-white;
  .v-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    background: $bh-blue;
  }
  img {
    display: block;
    max-height: 80vh;
    max-width: 1000px;
  }
  &--note {
    max-width: 320px;
    min-width: 250px;
    min-height: 200px;

    .theme--light {
      &.v-sheet--outlined {
        border: none;
      }
    }

    .v-card {
      &__title {
        padding-right: 44px;
      }
    }
  }
}
</style>
